import { createFileRoute } from "@tanstack/react-router";
import {
  createStructuredDataScript,
  generateWebApplicationStructuredData,
  seo,
  SEO_SITE_URL,
} from "@/lib/utils/seo";
import { RingGamePage } from "@/features/game/ring/ring-page";

export const Route = createFileRoute("/_index/game/ring")({
  component: RouteComponent,
  head: () => ({
    meta: [
      ...seo({
        title: "Apex 猜圈游戏 - 发现你的游戏风格 | CN Apex Club",
        description: "通过专业的 Apex Legends 猜圈游戏。",
        keywords: "Apex Legends,猜圈游戏,游戏测试,AI分析,游戏策略,CN Apex Club",
        url: `${SEO_SITE_URL}/game/ring`,
        type: "website",
      }),
    ],
    scripts: [
      createStructuredDataScript(
        generateWebApplicationStructuredData({
          name: "Apex 猜圈游戏",
          description: "精准猜圈是顶尖指挥的必备技能。",
          url: `${SEO_SITE_URL}/game/ring`,
        }),
      ),
    ],
  }),
});

function RouteComponent() {
  const { user } = Route.useRouteContext();
  return <RingGamePage currentUser={user} />;
}
